import React, { useState } from "react";
import Navbar from "./sections/navbar";
import Intro from "./sections/intro/index";
import Services from "./sections/services/index";
import Story from "./sections/story/index";
import Banner from "./sections/banner/index";
import Admission from "./sections/admission/index";
import Organizations from "./sections/organizations/index";
import Contact from "./sections/contact/index";
import Courses from "./sections/courses/index";
import Footer from "./sections/Footer/index";

import IntroEN from "./sections/intro/indexEN";
import ServicesEN from "./sections/services/indexEn";
import StoryEN from "./sections/story/indexEN";
import BannerEN from "./sections/banner/indexEN";
import AdmissionEN from "./sections/admission/indexEN";
import OrganizationsEN from "./sections/organizations/indexEN";
import ContactEN from "./sections/contact/indexEN";
import CoursesEN from "./sections/courses/indexEN";

const LandingGSA = (props) => {
  const [isSpanish, setIsSpanish] = useState(false);

  return (
    <div className="landing">
      
      {/* Resto de la página */}
      <Navbar isSpanish={isSpanish} setIsSpanish={setIsSpanish} />
      {isSpanish ? (
        <>
          <Intro />
          <Services />
          <Story isSpanish={isSpanish} />
          <Courses />
          <Admission />
          <Organizations />
          <Banner isSpanish={isSpanish} />
          <Contact />
        </>
      ) : (
        <>
          <IntroEN />
          <ServicesEN />
          <StoryEN isSpanish={isSpanish} />
          <CoursesEN />
          <AdmissionEN />
          <OrganizationsEN />
          <BannerEN isSpanish={isSpanish} />
          <ContactEN />
        </>
      )}
      <Footer />
    </div>
  );
};

export default LandingGSA;
